import { FC } from 'react';
import styled from 'styled-components';

import RelevantPost from './RelevantPost';

const RelevantPosts: FC<any> = ({ data, title }) => (
	<Relevant>
		<Container>
			<RelevantTitle>{title}</RelevantTitle>

			<Posts>
				{data?.map((post, index: number) => (
					<RelevantPost
						key={`relevant_post_${index}`}
						link={post?.url}
						image={post?.preview}
						title={post?.article?.title}
					/>
				))}
			</Posts>
		</Container>
	</Relevant>
);

const Relevant = styled.div`
	padding-top: 50px;
	padding-bottom: 50px;
	margin-top: 120px;
	background-color: var(--color-purple);
	border-top-left-radius: 65px;
	border-top-right-radius: 65px;

	@media (max-width: 500px) {
		border-top-left-radius: 30px;
		border-top-right-radius: 30px;
		margin-top: 50px;
	}
`;

const RelevantTitle = styled.h2`
	font-family: var(--font-sans);
	font-weight: var(--font-bold);
	font-size: 42px;
	line-height: 50px;
	color: var(--color-white);

	@media (max-width: 600px) {
		font-size: 30px;
		line-height: 40px;
		text-align: center;
	}

	@media (max-width: 500px) {
		text-align: left;
		font-size: 24px;
		margin-bottom: 25px;
	}
`;

const Posts = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin-top: 41px;

	@media (max-width: 900px) {
		flex-wrap: wrap;
		justify-content: space-between;
	}

	@media (max-width: 500px) {
		margin-top: 0;
	}
`;

const Container = styled.div`
	width: 960px;
	max-width: 90%;
	margin: 0 auto;
`;

export default RelevantPosts;
